export const defineSliderComponentCustomElement = (): void => {
  if (customElements.get("slider-component")) return;

  class SliderComponent extends HTMLElement {
    slider: any;
    sliderItems: any;
    enableSliderLooping: boolean;
    currentPageElement: any;
    pageTotalElement: any;
    prevButton: any;
    nextButton: any;

    sliderItemsToShow: any;
    sliderItemOffset: number;
    slidesPerPage: number;
    totalPages: number;
    currentPage: number;
    slideScrollPosition: number;

    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector(".slider-counter--current");
      this.pageTotalElement = this.querySelector(".slider-counter--total");
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      this.sliderItemsToShow = [];
      this.sliderItemOffset = 0;
      this.slidesPerPage = 0;
      this.totalPages = 0;
      this.currentPage = 0;
      this.slideScrollPosition = 0;

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      const resizeObserver = new ResizeObserver(() => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener("scroll", this.update.bind(this));

      if (!this.hasAttribute("data-external-nav")) {
        this.prevButton?.addEventListener("click", this.onButtonClick.bind(this));
        this.nextButton?.addEventListener("click", this.onButtonClick.bind(this));
      }
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element: any) => element.clientWidth > 0);
      if (this.querySelector(".slider-buttons")) {
        this.querySelector(".slider-buttons")?.classList.remove("hidden");
      }
      if (this.sliderItemsToShow.length > 1) {
        this.sliderItemOffset = this.sliderItemsToShow[1]?.offsetLeft - this.sliderItemsToShow[0]?.offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0]?.offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
        this.update();
      } else {
        if (this.querySelector(".slider-buttons") && !this.hasAttribute("data-external-nav")) {
          this.querySelector(".slider-buttons")?.classList.add("hidden");
        }
      }
    }

    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }

    update() {
      if (!this.slider || !this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = String(this.currentPage);
        this.pageTotalElement.textContent = String(this.totalPages);
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        );
      }

      if (this.enableSliderLooping) return;

      if ((this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) || this.currentPage > this.totalPages) {
        this.prevButton?.setAttribute("disabled", "disabled");
      } else {
        this.prevButton?.removeAttribute("disabled");
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton?.setAttribute("disabled", "disabled");
      } else {
        this.nextButton?.removeAttribute("disabled");
      }
    }

    isSlideVisible(element: any, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      if (element) {
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
      } else {
        return true;
      }
    }

    onButtonClick(event: any) {
      event.preventDefault();
      const step = event.currentTarget?.dataset?.step || 1;
      this.slideScrollPosition = event.currentTarget?.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;

      this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position: number) {
      this.slider.scrollTo({
        left: position,
      });
    }
  }

  customElements.define("slider-component", SliderComponent);
};
